import { isStartableState, isVerificationProcessing } from '../hooks/queries/useOwnershipVerification';

import type { PropertyOwnershipVerificationState } from '@zg-rentals/ts-rental-manager-api-client';

export type VerificationCtaLabel = 'Next' | 'Verify & publish';

/**
 * What a publish CTA promises when verification stands between the click and a live listing. Only a
 * state the landlord can still run reaches publishing — a submitted inquiry is the server's to
 * settle — and the publish step activates on its own only with freemium off and no contract to sign.
 */
export const getVerificationCtaLabel = ({
  state,
  isFreemiumEnabled,
  isContractRequired,
}: {
  state: PropertyOwnershipVerificationState | undefined;
  isFreemiumEnabled?: boolean;
  isContractRequired?: boolean;
}): VerificationCtaLabel =>
  isStartableState(state) && !isVerificationProcessing(state) && !isFreemiumEnabled && !isContractRequired
    ? 'Verify & publish'
    : 'Next';
